import React from "react"

import stopPropagation from "../../../../core/gd/utils/stop-propagation"
import {ModalPlacement} from "./@types"

type Props = {
    className?      : string,
    style?          : style

    placement?      : ModalPlacement

    children        : any
}

export default function ModalV5(props:Props)  {

    const placement = props.placement || ModalPlacement.MIDDLE

    const classes = Classes("v5-container", props.className, {
        'placement-middle'      : placement === ModalPlacement.MIDDLE,
        'placement-top'         : placement === ModalPlacement.TOP,
    })

    return (
        <div className  = {classes}
             style      = {props.style}
             onClick    = {stopPropagation}
        >
            {props.children}
        </div>
    )
}
